import SearchIcon from '@mui/icons-material/Search';
import {Box, InputAdornment, TextField} from '@mui/material';
import React from 'react';
import {SearchableState} from '../../../state/searchable-state';
import {SupportTicketMultiSelectFilter} from '../../support/ticket/components/SupportTicketMultiSelectFilter';

type Props = {
  searchText: string | null
  onSearchText: (value: string) => void
  searchableState: SearchableState
  extractAvailableValues: (column: string) => string[]
  translateLocal: (key: string) => string
  translate: (key: string) => string
}

export const CreditRequestFilterBar = ({searchableState, extractAvailableValues, translateLocal, translate, onSearchText, searchText}: Props) => {
  const translateModule = (m: string) => translate(`credit-support.module.${m}`)
  const translateStatus = (s: string) => translate(`credit-support.status.${s}`)
  const translatePriority = (p: string) => translate(`credit-support.priority.${p}`)

  return <Box display="flex" flexDirection="column" gap={2} mb={2}>
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <SupportTicketMultiSelectFilter
        label={translateLocal('column.organization')}
        column="credit_request.organization_name"
        searchableState={searchableState}
        options={extractAvailableValues('credit_request.organization_name').map(it => ({label: it, value: it}))}
      />
      <SupportTicketMultiSelectFilter
        label={translateLocal('column.account')}
        column="credit_request.account_name"
        searchableState={searchableState}
        options={extractAvailableValues('credit_request.account_name').map(it => ({label: it, value: it}))}
      />
      <SupportTicketMultiSelectFilter
        label={translateLocal('column.module')}
        column="credit_request.module"
        searchableState={searchableState}
        options={extractAvailableValues('credit_request.module').map(it => ({label: translateModule(it), value: it}))}
      />
      <SupportTicketMultiSelectFilter
        label={translateLocal('column.priority')}
        column="credit_request.priority"
        searchableState={searchableState}
        options={extractAvailableValues('credit_request.priority').map(it => ({label: translatePriority(it), value: it}))}
      />
      <SupportTicketMultiSelectFilter
        label={translateLocal('column.status')}
        column="credit_request.status"
        searchableState={searchableState}
        options={extractAvailableValues('credit_request.status').map(it => ({label: translateStatus(it), value: it}))}
      />
      <Box ml="auto" minWidth={300}>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          value={searchText || ''}
          onChange={(e) => onSearchText(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small"/></InputAdornment>
          }}
        />
      </Box>
    </Box>
  </Box>
}
